// extracted by mini-css-extract-plugin
module.exports = {"PageWrapper":"PageWrapper--2Qpnq","Margin":"Margin--3W9MT"};